import React, { createContext, useState, useContext } from 'react';

const AlbumContext = createContext();

export const AlbumProvider = ({ children }) => {
  const [albumDetails, setAlbumDetails] = useState({});
  const [artworkStatus, setArtworkStatus] = useState(null);
  const [audioStatus, setAudioStatus] = useState(null);
   const [ncfStatus, setNcfStatus] = useState(null);
  return (
    <AlbumContext.Provider value={{ albumDetails, setAlbumDetails, artworkStatus, setArtworkStatus,audioStatus, setAudioStatus,ncfStatus,setNcfStatus }}>
      {children}
    </AlbumContext.Provider>
  );
};

export const useAlbum = () => useContext(AlbumContext);
